import { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { FormikProps } from 'formik';
import { PQR_TYPE, PQR_TYPE_DETAIL } from '../../../../../routes/paths';
import {
    asyncGetParam,
    asyncGetPqrTypeHistorical,
    asyncPatchPqrTypeParam,
    asyncPostPqrTypeParam,
} from '../../../../../services/param.service';
import { ToastSwal } from '../../../../components/general/toastSwals/toastSwal';
import { Param, ParamHistorical } from '../../../../../shared/types/param';

export const usePqrTypeForm = () => {
    const navigate = useNavigate();
    const { idPqrType } = useParams();
    const [pqrType, setPqrType] = useState<Param>();
    const [loading, setLoading] = useState(false);
    const [formikPqrTypeData, setFormikPqrTypeData] =
        useState<FormikProps<Param>>();
    const [showHistorical, setShowHistorical] = useState(false);
    const [pqrTypeHistorical, setPqrTypeHistorical] =
        useState<ParamHistorical[]>();

    const isValidForm = formikPqrTypeData?.isValid;

    const handleCleanAndBack = () => {
        formikPqrTypeData?.resetForm();
        navigate(PQR_TYPE);
    };

    const handleSubmit = async () => {
        await formikPqrTypeData?.submitForm();

        if (!isValidForm) return;

        setLoading(true);

        const data: Param = formikPqrTypeData?.values;

        let res: any | undefined = undefined;

        try {
            if (pqrType && pqrType.id)
                res = await asyncPatchPqrTypeParam(pqrType.id, data);
            else res = await asyncPostPqrTypeParam(data);
        } catch (error) {}
        if (res?.items) {
            const item = Array.isArray(res?.items) ? res?.items[0] : res?.items;
            ToastSwal.fire({
                text: `¡Felicidades! el tipo de PQR se ${
                    pqrType && pqrType.id ? 'actualizo' : 'creó'
                } satisfactoriamente.`,
                icon: 'success',
                timer: 5000,
                position: 'center-end',
            });
            navigate(`${PQR_TYPE_DETAIL}/${item.id}`);
        } else {
            ToastSwal.fire({
                text: `Lo sentimos, no se pudo ${
                    pqrType && pqrType.id ? 'actualizar' : 'crear'
                } el tipo de PQR. Por favor, asegúrate de ${
                    pqrType && pqrType.id
                        ? 'diligenciar los datos correctamente'
                        : 'que no exista previamente'
                } e intenta nuevamente más tarde.`,
                icon: 'error',
                timer: 5000,
                position: 'center-end',
            });
        }

        setLoading(false);
    };

    useEffect(() => {
        if (Boolean(idPqrType)) {
            setLoading(true);
            asyncGetParam(idPqrType)
                .then((pqrType: any) => {
                    if (!pqrType || !pqrType.items) navigate(PQR_TYPE);
                    setPqrType(pqrType?.items);
                })
                .finally(() => setLoading(false));
        }
    }, [idPqrType]);

    useEffect(() => {
        if (showHistorical) {
            setLoading(true);
            asyncGetPqrTypeHistorical(idPqrType)
                .then((resp) => {
                    if (resp) setPqrTypeHistorical(resp);
                })
                .finally(() => setLoading(false));
        }
    }, [showHistorical]);

    return {
        pqrType,
        loading,
        isValidForm,
        handleSubmit,
        handleCleanAndBack,
        setFormikPqrTypeData,
        pqrTypeHistorical,
        showHistorical,
        setShowHistorical,
    };
};
